import { useTheme } from '@emotion/react';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { PublishProgressIcon } from './PublishProgressIcon';
import { ReviewSection } from './ReviewSection';

export const PublishedBadge: FunctionComponent<{ readonly isActive: boolean }> = ({ isActive }) => {
    const { translate } = useContext(ApplicationContext);
    const theme = useTheme();

    return (
        <ReviewSection
            color={isActive ? theme.colors.white[200] : theme.colors.success[300]}
            data-testid="review-state-published"
        >
            <PublishProgressIcon colorBase="currentColor" colorFill="currentColor" isActive={isActive} progress={1} />
            <span>{translate('pages.job-architecture-v2.review-state.published')}</span>
        </ReviewSection>
    );
};
